import script from "./CreditCalculatorZaymovich.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditCalculatorZaymovich.vue?vue&type=script&setup=true&lang=js"

import "./CreditCalculatorZaymovich.vue?vue&type=style&index=0&id=5b09e8c8&lang=css"

const __exports__ = script;

export default __exports__